export enum PaymentProcessor {
  PAYMENT_PROCESSOR_STRIPE = 'stripe',
  PAYMENT_PROCESSOR_PAYPAL = 'paypalpayments',
  PAYMENT_PROCESSOR_BLUESNAP = 'bluesnap',
  PAYMENT_PROCESSOR_PAYU = 'payu',
  PAYMENT_PROCESSOR_SQUARE = 'square',
  PAYMENT_PROCESSOR_QIWI = 'qiwi',
  PAYMENT_PROCESSOR_YANDEX = 'yandex',
}
